import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=b0501d70&scoped=true"
import script from "./AdminTasks.vue?vue&type=script&lang=js"
export * from "./AdminTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0501d70",
  null
  
)

export default component.exports